import { EntNavigation } from './ent-navigation';

/**
 * Main navigation
 * Accessible by Teachers and EDUID Managers
 */
export const navigation: EntNavigation[] = [
  {
    id: 'applications',
    title: 'Applications',
    translate: 'SIDENAV.APPLICATIONS',
    type: 'group',
    children: [
      {
        id: 'dashboard',
        title: 'Accueil',
        translate: 'SIDENAV.DASHBOARD.TITLE',
        type: 'item',
        icon: 'announcement',
        url: '/dashboard',
        maintenance: false,
      },
      {
        id: 'profile',
        title: 'Mon identité',
        translate: 'SIDENAV.PROFILE.TITLE',
        type: 'item',
        icon: 'verified_user',
        url: '/self',
        maintenance: false,
      },
      {
        id: 'users',
        title: 'Gestion des utilisateurs',
        translate: 'SIDENAV.USERS.TITLE',
        type: 'collapsable',
        icon: 'perm_identity',
        url: '/users',
        maintenance: false,
        children: [
          {
            id: 'user-single',
            title: 'Modifier un utilisateur',
            translate: 'SIDENAV.USERS.SINGLE',
            type: 'item',
            icon: 'edit',
            url: '/user',
            maintenance: false,
            hidden: true,
          },
        ],
      },
    ],
  },
];

export const RefInfonavigation: EntNavigation[] = [
  {
    id: 'applications',
    title: 'Applications',
    translate: 'SIDENAV.APPLICATIONS',
    type: 'group',
    children: [
      {
        id: 'dashboard',
        title: 'Accueil',
        translate: 'SIDENAV.DASHBOARD.TITLE',
        type: 'item',
        icon: 'announcement',
        url: '/dashboard',
        maintenance: false,
      },

      {
        id: 'profile',
        title: 'Mon identité',
        translate: 'SIDENAV.PROFILE.TITLE',
        type: 'item',
        icon: 'verified_user',
        url: '/self',
        maintenance: false,
      },
    ],
  },
  {
    id: 'administration',
    title: 'Administration',
    translate: 'SIDENAV.ADMINISTRATION',
    type: 'group',
    children: [
      {
        id: 'users',
        title: 'Gestion des utilisateurs',
        translate: 'SIDENAV.USERS.TITLE',
        type: 'collapsable',
        icon: 'perm_identity',
        url: '/users',
        maintenance: false,
        children: [
          {
            id: 'user-single',
            title: 'Modifier un utilisateur',
            translate: 'SIDENAV.USERS.SINGLE',
            type: 'item',
            icon: 'edit',
            url: '/user',
            maintenance: false,
            hidden: true,
          },
        ],
      },
      {
        id: 'orgs',
        title: 'Listes de distribution',
        translate: 'SIDENAV.ORGANISATION.TITLE',
        type: 'collapsable',
        icon: 'alternate_email',
        url: '/orgs',
        maintenance: false,
      },
    ],
  },
];

export const Menu4: EntNavigation[] = [
  {
    id: 'applications',
    title: 'Applications',
    translate: 'SIDENAV.APPLICATIONS',
    type: 'group',
    children: [
      {
        id: 'dashboard',
        title: 'Accueil',
        translate: 'SIDENAV.DASHBOARD.TITLE',
        type: 'item',
        icon: 'announcement',
        url: '/dashboard',
        maintenance: false,
      },
      {
        id: 'profile',
        title: 'Mon identité',
        translate: 'SIDENAV.PROFILE.TITLE',
        type: 'item',
        icon: 'verified_user',
        url: '/self',
        maintenance: false,
      },
    ],
  },
  {
    id: 'administration',
    title: 'Administration',
    translate: 'SIDENAV.ADMINISTRATION',
    type: 'group',
    children: [
      {
        id: 'portail',
        title: 'Informatique',
        translate: 'SIDENAV.PORTAIL.TITLE',
        type: 'collapsable',
        icon: 'dashboard',
        url: '/portail',
        maintenance: false,
      },
    ],
  },
];

export const Menu6: EntNavigation[] = [
  {
    id: 'applications',
    title: 'Applications',
    translate: 'SIDENAV.APPLICATIONS',
    type: 'group',
    children: [
      {
        id: 'dashboard',
        title: 'Accueil',
        translate: 'SIDENAV.DASHBOARD.TITLE',
        type: 'item',
        icon: 'announcement',
        url: '/dashboard',
        maintenance: false,
      },
      {
        id: 'profile',
        title: 'Mon identité',
        translate: 'SIDENAV.PROFILE.TITLE',
        type: 'item',
        icon: 'verified_user',
        url: '/self',
        maintenance: false,
      },
    ],
  },
  {
    id: 'administration',
    title: 'Administration',
    translate: 'SIDENAV.ADMINISTRATION',
    type: 'group',
    children: [
      {
        id: 'users',
        title: 'Gestion des utilisateurs',
        translate: 'SIDENAV.USERS.TITLE',
        type: 'collapsable',
        icon: 'perm_identity',
        url: '/users',
        maintenance: false,
        children: [
          {
            id: 'user-single',
            title: 'Modifier un utilisateur',
            translate: 'SIDENAV.USERS.SINGLE',
            type: 'item',
            icon: 'edit',
            url: '/user',
            maintenance: false,
            hidden: true,
          },
        ],
      },
      {
        id: 'portail',
        title: 'Portail Informatique',
        translate: 'SIDENAV.PORTAIL.TITLE',
        type: 'collapsable',
        icon: 'dashboard',
        url: '/portail',
        maintenance: false,
      },
    ],
  },
];

export const NewRefInfonavigation: EntNavigation[] = [
  {
    id: 'applications',
    title: 'Applications',
    translate: 'SIDENAV.APPLICATIONS',
    type: 'group',
    children: [
      {
        id: 'dashboard',
        title: 'Accueil',
        translate: 'SIDENAV.DASHBOARD.TITLE',
        type: 'item',
        icon: 'announcement',
        url: '/dashboard',
        maintenance: false,
      },
      {
        id: 'profile',
        title: 'Mon identité',
        translate: 'SIDENAV.PROFILE.TITLE',
        type: 'item',
        icon: 'verified_user',
        url: '/self',
        maintenance: false,
      },
    ],
  },
  {
    id: 'administration',
    title: 'Administration',
    translate: 'SIDENAV.ADMINISTRATION',
    type: 'group',
    children: [
      {
        id: 'users',
        title: 'Gestion des utilisateurs',
        translate: 'SIDENAV.USERS.TITLE',
        type: 'collapsable',
        icon: 'perm_identity',
        url: '/users',
        maintenance: false,
        children: [
          {
            id: 'user-single',
            title: 'Modifier un utilisateur',
            translate: 'SIDENAV.USERS.SINGLE',
            type: 'item',
            icon: 'edit',
            url: '/user',
            maintenance: false,
            hidden: true,
          },
        ],
      },
      {
        id: 'orgs',
        title: 'Listes de distribution',
        translate: 'SIDENAV.ORGANISATION.TITLE',
        type: 'collapsable',
        icon: 'alternate_email',
        url: '/orgs',
        maintenance: false,
      },
      {
        id: 'portail',
        title: 'Informatique',
        translate: 'SIDENAV.PORTAIL.TITLE',
        type: 'collapsable',
        icon: 'dashboard',
        url: '/portail',
        maintenance: false,
      },
    ],
  },
]; //new Ref Info

export const MenuSupport: EntNavigation[] = [
  {
    id: 'applications',
    title: 'Applications',
    translate: 'SIDENAV.APPLICATIONS',
    type: 'group',
    children: [
      {
        id: 'dashboard',
        title: 'Accueil',
        translate: 'SIDENAV.DASHBOARD.TITLE',
        type: 'item',
        icon: 'announcement',
        url: '/dashboard',
        maintenance: false,
      },
      {
        id: 'profile',
        title: 'Mon identité',
        translate: 'SIDENAV.PROFILE.TITLE',
        type: 'item',
        icon: 'verified_user',
        url: '/self',
        maintenance: false,
      },
    ],
  },
  {
    id: 'administration',
    title: 'Administration',
    translate: 'SIDENAV.ADMINISTRATION',
    type: 'group',
    children: [
      {
        id: 'users',
        title: 'Gestion des utilisateurs',
        translate: 'SIDENAV.USERS.TITLE',
        type: 'collapsable',
        icon: 'perm_identity',
        url: '/users',
        maintenance: false,
        children: [
          {
            id: 'user-single',
            title: 'Modifier un utilisateur',
            translate: 'SIDENAV.USERS.SINGLE',
            type: 'item',
            icon: 'edit',
            url: '/user',
            maintenance: false,
            hidden: true,
          },
        ],
      },
      {
        id: 'orgs',
        title: 'Listes de distribution',
        translate: 'SIDENAV.ORGANISATION.TITLE',
        type: 'collapsable',
        icon: 'alternate_email',
        url: '/orgs',
        maintenance: false,
      },
      {
        id: 'portail',
        title: 'Informatique',
        translate: 'SIDENAV.PORTAIL.TITLE',
        type: 'collapsable',
        icon: 'dashboard',
        url: '/portail',
        maintenance: false,
      },
    ],
  },
  {
    id: 'administration',
    title: 'ADMINISTRATION ICTVS',
    translate: 'SIDENAV.SUPPORT-ADMIN.TITLE',
    type: 'group',
    children: [
      {
        id: 'support-ictvs',
        title: 'Support',
        translate: 'SIDENAV.SUPPORT-ADMIN.ADMIN',
        type: 'collapsable',
        icon: 'power_settings_new',
        url: '/support',
        maintenance: false,
      },
    ],
  },
]; //Menu support

export const studentNavigation: EntNavigation[] = [
  {
    id: 'applications',
    title: 'Applications',
    translate: 'SIDENAV.APPLICATIONS',
    type: 'group',
    children: [
      {
        id: 'dashboard',
        title: 'Accueil',
        translate: 'SIDENAV.DASHBOARD.TITLE',
        type: 'item',
        icon: 'announcement',
        url: '/dashboard',
        maintenance: false,
      },
      {
        id: 'profile',
        title: 'Identité numérique',
        translate: 'SIDENAV.PROFILE.TITLE',
        type: 'item',
        icon: 'verified_user',
        url: '/self',
        maintenance: false,
      },
    ],
  },
]; // StudentNavigation

// Administration Panel item
export const adminPanelItem: EntNavigation = {
  id: 'administration-panel',
  title: 'Administratoin Panel',
  translate: 'SIDENAV.ADMINISTRATION-ITEM',
  type: 'item',
  icon: 'admin_panel_settings',
  url: '/administration',
  maintenance: false,
};

// Administration Panel
export const adminPanel: EntNavigation = {
  id: 'administration',
  title: 'Administration',
  translate: 'SIDENAV.ADMINISTRATION',
  type: 'group',
  children: [],
};
